module.exports = __webpack_public_path__ + "img/rimg.92e5ec82.png";